/// <reference path="../../setup/_references.ts" />
module onvio.practice.widgets {
    'use strict';

    export class BmPracticeWidgetAccountsReceivableService {

        static $inject = [
            '$translate',
            '$window',
            '$uibModal'
        ];
        constructor(
            private $translate: ng.translate.ITranslateService,
            private $window: ng.IWindowService,
            private $uibModal: angular.ui.bootstrap.IModalService) {
                // Nothing required here
        }

    }

    angular.module('bm.practice.widgets.AccountsReceivableService', [])
        .service('bmPracticeWidgetAccountsReceivableService', BmPracticeWidgetAccountsReceivableService);
}
